/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:06]
Permissions to update outside the main branch: [false]
*/

import {
    Button,
    useActionsBtnContext,
    useErrorState,
    useGridFilterUrlContext,
} from '@finbeat/react-toolkit';
import { faTrashRestore } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AxiosError } from 'axios';
import { restoreUser } from 'axios/userApi';
import useApi from 'hooks/useApi';
import { usePingCrmApiCallback } from 'hooks/usePingCrmApiCallback';
import { AxiosErrorResponse } from 'models/api/axiosErrorResponse';
import { UserRestore } from 'models/api/users';
import Id from 'models/id';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import 'scss/Main.scss';
import { useUserWorkplaceState } from '../Users';

type UserDeleteBtnProps = { isExternalUser: boolean } & Id;

export default function UserRestoreBtn({ id, isExternalUser }: UserDeleteBtnProps) {
    const { t } = useTranslation();
    const api = useApi();
    const { filter, setFilter } = useGridFilterUrlContext();
    const { tableData, fetchQuery } = useUserWorkplaceState();
    const { handleRequestError } = useErrorState();
    const restoreMutation = useMutation(
        ({ id, crmSync }: UserRestore) => restoreUser(api, id, crmSync),
        {
            onSuccess: () => {
                const pageNum = filter?.pageNum;
                if (pageNum && pageNum > 1 && tableData?.data?.length === 1) {
                    setFilter((prevState) => ({
                        ...prevState,
                        pageNum: pageNum - 1,
                    }));
                } else {
                    fetchQuery.refetch();
                }
            },
            onError: (err: AxiosError<AxiosErrorResponse>) => handleRequestError(err),
        }
    );
    const { addRequest } = useActionsBtnContext();
    const pingCrm = usePingCrmApiCallback();

    return (
        <div>
            <Button
                className="workplace-delete-btn popover-btn"
                type="button"
                onClick={() => {
                    addRequest({
                        content: t('BackOfficeAreYouSure'),
                        confirmCallback: (res) => {
                            if (res && id !== undefined) {
                                if (isExternalUser) {
                                    restoreMutation.mutate({ id: id, crmSync: false });
                                } else {
                                    pingCrm((props) =>
                                        props.available
                                            ? id &&
                                              restoreMutation.mutate({ id: id, crmSync: true })
                                            : props.resp &&
                                              id &&
                                              restoreMutation.mutate({ id: id, crmSync: false })
                                    );
                                }
                            }
                        },
                    });
                }}
            >
                <FontAwesomeIcon icon={faTrashRestore} className="workplace-action-btn__icon" />
                <span>{t('BackOfficeRestore')}</span>
            </Button>
        </div>
    );
}
